import React, { useContext } from "react"

import cn from "classnames"

import { AuthContext, AUTH_FLOW_COMPONENTS } from "../contexts/Auth"

import as from "../styles/auth-styles.module.scss"

const ForgotPasswordForm = () => {

    const {
        sendOutPasswordReset,
        passwdResetError,
        setLoginError,
        setPasswdResetError,
        setCurrAuthComponent
    } = useContext(AuthContext)

    // const haveError = () => "" !== passwdResetError

    const handleRememberedPasswd = (event) => {
        event.preventDefault()
        setLoginError("")
        setCurrAuthComponent(AUTH_FLOW_COMPONENTS.LOGIN)
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        const { email } = event.target.elements;
        setLoginError("")
        sendOutPasswordReset(email.value)
            .then(() => {
                console.log("password reset set")
            })
            .catch((error) => {
                setPasswdResetError(error.message)
            })
    }

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <div className={as.container}>
                    <div className={as.row}>
                       <h3>MedDBriefer Password Reset Form</h3>
                    </div>
                    <div className={as.row}>
                        <label
                            htmlFor="email"
                            className={cn(as['col-sm-1'], as['col-form-label'])}
                        >
                            Email
                        </label>
                        <div className={as['col-sm-11']}>
                            <input
                                id="email"
                                name="email"
                                type="email"
                                className={as['form-control']}
                                placeholder="Enter email"
                                required
                            />
                        </div>
                    </div>
                    <div className={as.row}>
                        <p className={as['text-danger']}>
                            {passwdResetError}
                        </p>
                    </div>
                    <div className={as.row}>
                        <button
                            type="submit"
                            className={cn(as.btn, as['btn-primary'])}
                        >
                            Send Password Reset Email
                        </button>
                        <button
                            type="button"
                            className={cn(as.btn, as['btn-link'])}
                            onClick={handleRememberedPasswd}
                        >
                            I remembered my password!
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default ForgotPasswordForm